import { Point } from '@gush/candybar';
import openSrc from '../images/hand-open.png';
import pinchSrc from '../images/hand-pinch.png';
import upSrc from '../images/hands-up.png';

const OFF_X = 0.81;
const OFF_Y = 0.26;
const PI = Math.PI;
const PI_4 = PI / 4;
const HAND_UP_TIME = 1500;

export default class Hand {
    setup = ({ dpr, bounds }) => {
        this.origin = new Point(bounds.w / 2, bounds.h / 2);

        const open = document.createElement('img');
        const pinch = document.createElement('img');
        const up = document.createElement('img');

        open.addEventListener('load', ({ target }) => {
            this.open = target;
        });
        pinch.addEventListener('load', ({ target }) => {
            this.pinch = target;
        });
        up.addEventListener('load', ({ target }) => {
            this.up = target;
        });

        open.src = openSrc;
        pinch.src = pinchSrc;
        up.src = upSrc;
    };

    setHandDown = ({ x = 0, y = 0 } = {}) => {
        console.log('setHandDown');
        this.origin = new Point(x, y);
        this.handUp = false;
        this.mousedown = true;
    };

    setHandUp = () => {
        clearTimeout(this.timer);
        this.mousedown = false;
        this.handUp = true;
        // this.timer = setTimeout(this.setHandOpen, HAND_UP_TIME);
    };

    setHandOpen = () => {
        this.mousedown = false;
        this.handUp = false;
    };

    draw = ({ pointer, ctx, dpr }) => {
        if (!this.open && !this.pinch) return;

        const { x, y } = pointer.position;

        const img = this.handUp
            ? this.up
            : this.mousedown
            ? this.pinch
            : this.open;

        const theta = this.origin.angleRadians({ x, y });

        ctx.save();
        ctx.translate(x, y);
        const w = img.width / 2;
        const h = img.height / 2;
        const ix = w * OFF_X * dpr;
        const iy = h * OFF_Y * dpr;
        const iw = w * dpr;
        const ih = h * dpr;

        if (x === this.origin.x && y === this.origin.y) {
            ctx.drawImage(img, -ix, -iy, iw, ih);
        } else if (x > this.origin.x) {
            ctx.rotate(this.mousedown ? theta - PI_4 : 0);
            ctx.scale(-1, 1);
            ctx.drawImage(img, -ix, -iy, iw, ih);
        } else {
            ctx.rotate(this.mousedown ? theta + PI + PI_4 : 0);
            ctx.drawImage(img, -ix, -iy, iw, ih);
        }

        ctx.restore();
    };
}
